/**
 * Trust amount calculation - same formula as juniper-eligible-matter-view rebuild.
 * Open/Pending Matters: MinThreshold - (TrustBalance - (OutstandingBalance + WIP))
 */
export function calculateTrustAmount(
  minimumThreshold: number,
  trustBalance: number,
  outstandingBalance: number,
  wip: number
): number {
  const minTh = Number(minimumThreshold) || 0;
  const trust = Number(trustBalance) || 0;
  const outstanding = Number(outstandingBalance) || 0;
  const w = Number(wip) || 0;
  const result = Math.max(0, minTh - (trust - (outstanding + w)));
  const formatted = result.toFixed(2) + '00';
  const trimmed = formatted.substring(0, formatted.indexOf('.') + 3);
  return Number(trimmed);
}
